import { useEffect, useState } from 'react';
import { Banner, Footer, Navbar } from '../components';
import { Typography } from '@material-tailwind/react';
import MapContainer from '../components/MapContainer';
import ubiarea from "../assets/images/area.webp"


const SCHEDULE = [
  { label: " Registration" },
  { label: " Opening Session" },
  { label: " Keynote Speech by Ruben Vera Rodríguez", details: "Talk: 'Advances in Behavioral Mobile Biometrics and in Face Recognition through AI Generated Images'" },
  { label: " Main Sponsor Presentation", details: "Speaker: Ricardo Carvalho, DXC Technology" },
  { label: " Coffee Break" },
  { label: " Poster Session I + Exhibition Stands", link: "/program/sessions/1" },
  { label: " Lunch Break" },
  { label: " Poster Session II + Exhibition Stands", link: "/program/sessions/2" },
  { label: " Poster Session III + Exhibition Stands", link: "/program/sessions/3" },
  { label: " Coffee Break" },
  { label: " Oral Presentations", details: "Various presentations on breast cancer, lung cancer, AI, and more." },
  { label: " Closing Session", details: "Best Paper and Master's Dissertation Awards" }
];

const TIMES = [
  "9h00",
  "9h30",
  "10h00",
  "11h00",
  "11h20",
  "11h45",
  "12h30",
  "14h00",
  "14h45",
  "15h30",
  "16h00",
  "17h00",

]




export function Program() {
  const [navbarTransparent, setNavbarTransparent] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="w-full relative">
        <Navbar transparent={navbarTransparent} />
        <Banner title={"Program"} />

        <section className="w-full container mx-auto px-0 lg:py-12 lg:px-14" >

          <div className="flex flex-col justify-center  w-full h-full p-8">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Program
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              Like in previous years, the event program will feature the presentation of the majority of papers in poster format, and the oral presentation of the top 4 papers submitted to the conference. We are pleased to announce the confirmed participation of an internationally renowned guest speaker. Additionally, the program will include an awards ceremony to honor exceptional contributions in paper, poster, and master's thesis categories.
            </Typography>

            <ul className="list-disc font-normal mt-4 pl-4">
              {SCHEDULE.map((item, index) => (
                <li key={index} className="font-normal text-gray-600">
                  {item.link ? (
                    <>
                      <span><strong>{TIMES[index]}:</strong></span>
                      <a href={item.link} className="text-blue-500 underline">
                        {item.label}
                      </a>
                    </>

                  ) : (
                    <>
                      <span><strong>{TIMES[index]}:</strong></span>
                      <span>{item.label}</span>

                    </>
                  )}
                  {item.details && <p className="text-gray-500">{item.details}</p>}
                </li>
              ))}
            </ul>


          </div>

        </section>

        <section className="w-full container mx-auto px-8 py-6 lg:py-12 lg:px-14" >

          <Typography variant="h3" color="blue-gray" className="mb-2">
            Conference Location
          </Typography>
          <Typography color="gray" className="font-normal mt-2">
            The event will take place at <strong><a className="underline" target='_blank' href="https://maps.app.goo.gl/b4J1VHxGusmSbX1V6">Universidade da Beira Interior - Faculdade de Ciências da Saúde, Av. Infante D. Henrique, 6200-506 Covilhã</a></strong>
          </Typography>
          <MapContainer />

          <div className="mt-10">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Convenient parking and access
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              The <strong>Faculdade de Ciências da Saúde</strong> offers ample parking, a convenient location, and easy access to a variety of dining options.
            </Typography>
          </div>
          <div className="w-full flex justify-center mt-12" >
            <img
              src={ubiarea}
              alt="ubi_parking_area"
              className="h-full w-full max-w-[600px] object-cover"
            />
          </div>


        </section>
        <Footer />

      </div>
    </>
  );
}
